import { Controller } from "@hotwired/stimulus"

// Header controller with logo transition on scroll and mobile menu toggle
export default class extends Controller {
  static targets = ["mobileMenu", "menuButton", "floatingLogo", "headerLogo", "nav"]
  static values = {
    hideThreshold: { type: Number, default: 300 }
  }

  connect() {
    this.onScroll = this.onScroll.bind(this)
    this.lastScrollY = 0
    this.setupHeader()

    window.addEventListener('scroll', this.onScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener('scroll', this.onScroll)
  }

  setupHeader() {
    if (this.hasNavTarget) {
      this.navTarget.style.transition = 'transform 0.3s ease-in-out'
    }
  }

  isMobile() {
    return window.innerWidth < 1024
  }

  onScroll() {
    const scrollY = window.scrollY
    const scrollingDown = scrollY > this.lastScrollY

    if (this.hasNavTarget) {
      // On mobile, nav is always visible
      if (this.isMobile()) {
        this.navTarget.style.transform = 'translateY(0)'
      }
      // On desktop, auto-hide behavior
      else if (scrollY < this.hideThresholdValue) {
        this.navTarget.style.transform = 'translateY(0)'
      }
      else if (scrollingDown) {
        this.navTarget.style.transform = 'translateY(-100%)'
      }
      else {
        this.navTarget.style.transform = 'translateY(0)'
      }
    }

    // Desktop: toggle between floating logo and header logo
    if (!this.isMobile()) {
      if (scrollY > this.hideThresholdValue) {
        // Hide floating logo, show header logo
        if (this.hasFloatingLogoTarget) this.floatingLogoTarget.classList.add('lg:hidden')
        if (this.hasHeaderLogoTarget) this.headerLogoTarget.classList.remove('lg:hidden')
      } else {
        // Show floating logo, hide header logo
        if (this.hasFloatingLogoTarget) this.floatingLogoTarget.classList.remove('lg:hidden')
        if (this.hasHeaderLogoTarget) this.headerLogoTarget.classList.add('lg:hidden')
      }
    }

    this.lastScrollY = scrollY
  }

  toggleMenu() {
    if (!this.hasMobileMenuTarget) return

    const isHidden = this.mobileMenuTarget.classList.toggle("hidden")

    if (this.hasMenuButtonTarget) {
      this.menuButtonTarget.setAttribute('aria-expanded', !isHidden)
    }

    // When menu is open, nav goes above floating logo
    if (this.hasNavTarget) {
      if (!isHidden) {
        this.navTarget.style.zIndex = '70'
      } else {
        this.navTarget.style.zIndex = ''
      }
    }
  }
}
